var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"title":"Edit Reservations","containerFluid":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.isAdmin)?_c('reservation-modal-edit',{attrs:{"showInModal":true}}):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }